module.exports = __webpack_public_path__ + "static/media/carriere.8a138978.svg";